import { Component } from '@angular/core';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';

@Component({
  selector: 'app-impact-assessment-dashboard2',
  templateUrl: './impact-assessment-dashboard2.component.html',
  styleUrls: ['./impact-assessment-dashboard2.component.scss']
})
export class ImpactAssessmentDashboard2Component {
  joseToken:any= [];
  streamlitUrl!: string;
  isLoading = false;
  constructor(private userService:UserManagementService) {
    this.getDashboardReport();
  }

  getDashboardReport(){
    this.isLoading = true;
    this.userService.generateJoseJWT("impactAssessment")
      .subscribe((config: string) => {
        this.joseToken = config;
        this.streamlitUrl = "https://dashboards.finreg-e.com/?key=" + this.joseToken.message;
        this.isLoading = false;
      });
  }


}

